import { memo } from 'react';
import type { CommissionRateType } from './types';

const META: Record<CommissionRateType, { label: string; cls: string }> = {
  PERCENTAGE: { label: 'Percentage', cls: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300' },
  FLAT_PER_BILL: { label: 'Flat / Bill', cls: 'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-300' },
  FLAT_PER_ITEM: { label: 'Flat / Item', cls: 'bg-fuchsia-100 text-fuchsia-700 dark:bg-fuchsia-900/30 dark:text-fuchsia-300' },
};

export const RateTypeBadge = memo(function RateTypeBadge({ type }: { type: CommissionRateType }) {
  const m = META[type] ?? META.PERCENTAGE;
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${m.cls}`}>
      {m.label}
    </span>
  );
});
